export default __webpack_public_path__ + "static/media/9450c59fafecf4877b250561c8cae7ab.png";